import { SxProps } from "@mui/material";

export const inputProps: SxProps = {
    color: "var(--text)",
    margin: ".5rem",
    width: "calc(100% - 1rem)",
    background: 'var(--bg)',
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--border)",
    },
    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--selected) !important",
        boxShadow: "0 0 0 .2rem var(--input-focus)",
        marginTop:".2rem"
    },
    "& :hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--cell-border) !important"
    },
    "& .MuiSelect-icon": {
        color: "var(--text)"
    },
    "& .Mui-focused": {
        borderColor: "var(--selected)",
    },
    "& label.Mui-focused": {
        color: "var(--selected)",
    },
    "& label": {
        color: "var(--text)",
        lineHeight: "1rem",
        top:"-4px"
    },
    "& input": {
        color: "var(--text)",
        padding:"8px 8px"
    },
    "& .MuiSelect-select": {
        padding: "4px 8px"
    }
    
}
export const OutlinedInputProps = {
    color: "var(--text)",
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--border)",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--selected)",
        boxShadow: "0 0 0 .25rem var(--input-focus)",
    },
    "& .MuiSelect-icon": {
        color: "var(--text)"
    }
}
const ITEM_HEIGHT = 36;
const ITEM_PADDING_TOP = 8;

export const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
            color: "var(--text)",
            borderColor: "var(--border)"
        },
    },
};